import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const SideMenu = () => {
  const [active, setActive] = useState("home");

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* BASIC SIDE MENUS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Side Menus</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Simple Side Menu</label>
            <div className="flex gap-2 h-32">
              <nav className="w-32 border-r border-slate-600 py-2">
                {["Home", "About", "Contact"].map(item => (
                  <button key={item} className={`w-full px-3 py-2 text-left text-sm ${active === item.toLowerCase() ? "bg-amber-900 text-amber-300 border-l-2 border-amber-400" : "text-slate-400 hover:bg-slate-800"}`} onClick={() => setActive(item.toLowerCase())}>
                    {item}
                  </button>
                ))}
              </nav>
              <div className="flex-1 p-2 text-slate-400">Content</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<nav className="w-32 border-r border-slate-600">
  <button className="w-full px-3 py-2 text-left">Home</button>
  <button className="w-full px-3 py-2 text-left">About</button>
</nav>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Icons</label>
            <div className="flex gap-2 h-32">
              <nav className="w-36 border-r border-slate-600 py-2">
                {[{icon: "", label: "Home"}, {icon: "", label: "Settings"}, {icon: "", label: "Profile"}].map(item => (
                  <button key={item.label} className="w-full px-3 py-2 text-left text-sm flex items-center gap-2 text-slate-400 hover:bg-slate-800">
                    <span>{item.icon}</span>
                    <span>{item.label}</span>
                  </button>
                ))}
              </nav>
              <div className="flex-1 p-2 text-slate-400">Content</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<button className="w-full flex items-center gap-2 px-3 py-2">
  <span></span>
  <span>Home</span>
</button>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">With Submenus</label>
            <div className="flex gap-2 h-40">
              <nav className="w-40 border-r border-slate-600 py-2 text-sm">
                <button className="w-full px-3 py-2 text-left text-slate-400 hover:bg-slate-800 font-medium">Dashboard</button>
                <button className="w-full px-4 py-1.5 pl-6 text-left text-slate-500 text-xs hover:bg-slate-800">Overview</button>
                <button className="w-full px-4 py-1.5 pl-6 text-left text-slate-500 text-xs hover:bg-slate-800">Analytics</button>
                <button className="w-full px-3 py-2 text-left text-slate-400 hover:bg-slate-800 font-medium mt-2">Settings</button>
              </nav>
              <div className="flex-1 p-2 text-slate-400">Content</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<nav className="w-40 border-r border-slate-600">
  <button className="w-full px-3 py-2 font-medium">Dashboard</button>
  <button className="w-full px-6 py-1.5 text-sm">Overview</button>
  <button className="w-full px-6 py-1.5 text-sm">Analytics</button>
</nav>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Colored Menu</label>
            <div className="flex gap-2 h-32">
              <nav className="w-32 bg-gradient-to-b from-slate-800 to-slate-900 border-r border-slate-600 py-2">
                {["Purple", "Cyan", "Pink"].map(item => (
                  <button key={item} className="w-full px-3 py-2 text-left text-sm text-slate-400 hover:bg-slate-700 hover:text-slate-200">
                    {item}
                  </button>
                ))}
              </nav>
              <div className="flex-1 p-2 text-slate-400">Content</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<nav className="bg-gradient-to-b from-slate-800 to-slate-900 border-r">
  <button className="w-full px-3 py-2 text-left">Item</button>
</nav>`} />
          </div>
        </div>
      </div>

      {/* ADVANCED MENUS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Advanced Variants</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Sidebar with Badges</label>
            <div className="flex gap-2 h-32">
              <nav className="w-40 border-r border-slate-600 py-2 text-sm">
                <div className="px-3 py-2 flex justify-between items-center text-slate-400">
                  <span>Inbox</span>
                  <span className="bg-red-600 text-white text-xs px-2 py-0.5 rounded-full">3</span>
                </div>
                <div className="px-3 py-2 flex justify-between items-center text-slate-400">
                  <span>Archive</span>
                </div>
              </nav>
              <div className="flex-1 p-2 text-slate-400">Content</div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="flex justify-between items-center">
  <span>Inbox</span>
  <span className="bg-red-600 text-white px-2 py-0.5 rounded-full">3</span>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SideMenu;


